document.addEventListener("DOMContentLoaded", () => {
  let listContainers = document.querySelectorAll('.wp-block-introduction-list__item');
  if (listContainers) {
    listContainers.forEach((listContainer) => {
      let toggle = listContainer.querySelector('.button');
      let body = listContainer.querySelector('.wp-block-introduction-list__item-body');

      listContainer.addEventListener('click', (event) => {
        if (body) {
          listContainer.classList.toggle('wp-block-introduction-list__item--active');
        }

        if (toggle) {
          toggle.classList.toggle('button--plus');
          toggle.classList.toggle('button--minus');
        }
        event.preventDefault();
      });
    });
  }
});
